import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 24"
    ref={ref}
    {...props}
  >
    <path d="m12.791 2.162 9.028 7.626v.007c.447.381.511 1.057.135 1.518a1.04 1.04 0 0 1-.816.388c-.241 0-.483-.086-.682-.252l-9.028-7.625a.36.36 0 0 0-.454 0l-9.028 7.618a1.05 1.05 0 0 1-1.498-.136 1.085 1.085 0 0 1 .135-1.518l3.52-2.972v-4.97c0-.584.469-1.058 1.044-1.058h.752c.575 0 1.043.474 1.043 1.057v2.568l2.67-2.251a2.46 2.46 0 0 1 3.179 0m4.442 10.618c0-.597.476-1.079 1.065-1.079s1.064.482 1.064 1.08v7.913c0 1.389-1.114 2.518-2.484 2.518h-2.13c-1.369 0-2.483-1.13-2.483-2.518v-3.597a1.07 1.07 0 0 0-1.065-1.08 1.07 1.07 0 0 0-1.065 1.08v3.597c0 1.389-1.114 2.518-2.484 2.518h-2.13c-1.37 0-2.483-1.13-2.483-2.518V12.78a1.07 1.07 0 0 1 1.064-1.079c.59 0 1.065.482 1.065 1.08v7.913c0 .202.156.36.355.36h2.13a.354.354 0 0 0 .354-.36v-3.597c0-1.784 1.434-3.237 3.194-3.237s3.194 1.453 3.194 3.237v3.597c0 .202.156.36.355.36h2.13a.354.354 0 0 0 .354-.36z" />
  </svg>
);
const ForwardRef = forwardRef(SvgHome);
export default ForwardRef;
